var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"meeting-video",class:['meeting-video--' + _vm.fit, { 'meeting-video--mirror': _vm.mirror }],attrs:{"autoplay":"","playsinline":""},domProps:{"muted":_vm.muted}})}
var staticRenderFns = []

export { render, staticRenderFns }